import { call, put, all, takeLatest } from 'redux-saga/effects';

import { getTabsData as getTabsConsulta } from '../../../services/proposta';
import { getTabsData as getTabsAnalise } from '../../../services/analisePagamento';
import { loadTabsConsultaSuccess, loadTabsAnaliseSuccess } from './actions';

function* loadTabsConsulta({ payload }) {
  const { IdContrato } = payload;
  const tabs = yield call(getTabsConsulta, IdContrato);

  yield put(loadTabsConsultaSuccess(tabs));
}

function* loadTabsAnalise({ payload }) {
  const { IdContrato, reanalise } = payload;

  const tabs = yield call(getTabsAnalise, IdContrato, reanalise);

  yield put(loadTabsAnaliseSuccess(tabs));
}

export default all([
  takeLatest('@proposta/LOAD_TABS_CONSULTA_REQUEST', loadTabsConsulta),
  takeLatest('@proposta/LOAD_TABS_ANALISE_REQUEST', loadTabsAnalise),
]);
